import React from "react";
import { useTranslation } from "react-i18next";
import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemButton,
	AccordionItemPanel,
} from "react-accessible-accordion";
import styled from "styled-components";

import AppText from "../../../../components/Core/AppText/AppText";
import { ICON_TYPE } from "../../../../configs/constants/IconsTypes";
import Flex from "../../../../components/Layout/Flex";
import { getHistoryMetadataString } from "../../../../utils/recruitment.utils";
import { History } from "../../../../models/RecruitmentHistory";
import ThirdLevel from "./ThirdLevel";
import { appTheme } from "../../../../theme/Theme";

type ActionLineProps = {
	label: string;
	date: Date;
	firstName?: string;
	lastName?: string;
	icon: ICON_TYPE;
	subActions?: boolean;
};

const ActionLine: React.FC<ActionLineProps> = ({
	label,
	date,
	firstName,
	lastName,
	icon,
	subActions = false,
}) => {
	const { t } = useTranslation();

	return (
		<>
			<ActionImage src={icon} alt="action-icon" />
			<Flex direction="column">
				<AppText size="m" color="black">
					{t(label as any)}
				</AppText>
				{subActions ? (
					<ActionsDateText>{getHistoryMetadataString(date, firstName, lastName)}</ActionsDateText>
				) : (
					<AppText size="xs" color="grayTextLight" margin="4px 0 0 0">
						{getHistoryMetadataString(date, firstName, lastName)}
					</AppText>
				)}
			</Flex>
		</>
	);
};

interface SecondLevelProps {
	actionItem: History;
	icon: ICON_TYPE;
}

const SecondLevel: React.FC<SecondLevelProps> = ({
	actionItem: { data, date, id, items, type, user },
	icon,
}) => {
	const label = data?.currentAction as string;

	return items && items.length > 0 ? (
		<Accordion allowMultipleExpanded allowZeroExpanded key={id}>
			<AccordionItem>
				<AccordionItemHeading>
					<AccordionItemButton className="accordion__button action_item-button">
						<Flex alignItems="flex-start">
							<ActionLine
								label={label}
								date={date}
								firstName={user?.firstName}
								lastName={user?.lastName}
								icon={icon}
								subActions
							/>
						</Flex>
					</AccordionItemButton>
				</AccordionItemHeading>
				<AccordionItemPanel className="actions_sub-panel">
					{items.map((actionSubItem: History) => (
						<ThirdLevel actionSubItem={actionSubItem} key={actionSubItem.id} />
					))}
				</AccordionItemPanel>
			</AccordionItem>
		</Accordion>
	) : (
		<Flex
			alignItems="flex-start"
			minHeight="50px"
			margin="0 0 35px 0"
			className="action_main-wrapper"
		>
			<ActionLine
				label={label}
				date={date}
				firstName={user?.firstName}
				lastName={user?.lastName}
				icon={icon}
			/>
		</Flex>
	);
};

export default SecondLevel;

const ActionsDateText = styled.p`
	position: absolute;
	left: 54px;
	top: 24px;
	color: ${appTheme.colors.COLOR_GRAY_TEXT_LIGHT};
	font-size: 0.75rem;
	width: max-content;
`;

const ActionImage = styled.img`
	margin-right: 15.4px;
	position: relative;
	z-index: 2;
	padding: 3px;
	background: ${appTheme.colors.COLOR_LIGHT_GRAY};
`;
